export default {
  resetPassword: 'RESET_PASSWORD',
  resetPasswordSuccess: 'RESET_PASSWORD_SUCCESS',
  resetPasswordFailed: 'RESET_PASSWORD_FAILED',
  resetToInitialState: 'RESET_PASSWORD_RESET_TO_INITIAL_STATE',

  changePassword: 'CHANGE_PASSWORD',
  changePasswordSuccess: 'CHANGE_PASSWORD_SUCCESS',
  changePasswordFailed: 'CHANGE_PASSWORD_FAILED',
};
